<section id="group-img-edit" class="editCoverDiv">
    <div class="images-box">
        <div class="images-cover">
            <img class="images-cover-create c2" *ngIf="coverShowImg" [src]="coverImgSrc|getImgPath:'images'" alt="">
            <img class="images-cover-create c1" *ngIf="!coverShowImg" [src]="coverImgSrc|getImgPath:'images'" alt="">
            <input type="file" #coverChangeImg hidden (change)="createImage($event, 'square')">
            <button (click)="coverChangeImg.click()" class="position-btn">
                <mat-icon>
                    create
                </mat-icon>
            </button>
        </div>
        <div class="images-avatar">
            <!--            <img *ngIf="!coverShowImg" [src]="coverImg|getImgPath:'images'" alt="">-->
            <img *ngIf="!avatarShowImg" [src]="avatarImgSrc|getImgPath:'images'" alt="">
            <img *ngIf="avatarShowImg" [src]="avatarImgSrc" alt="">
            <!--            <mat-icon *ngIf="!avatarImgSrc">add_a_photo</mat-icon>-->
            <input type="file" #avatarChangeImg hidden (change)="createImage($event, 'circle')">
            <button (click)="avatarChangeImg.click()" class="position-btn">
                <mat-icon>
                    create
                </mat-icon>
            </button>
        </div>
    </div>
    <div class="images-save-btn-box" *ngIf="(avatarImgSrc && discardORSave) || (coverImgSrc && discardORSave)">
        <button class="save-btn" (click)="saveAvatarImage(avatarImgSrc,coverImgSrc)">Save</button>
        <button class="discard-btn" (click)="remuveAvatarImage('','')">DISCARD</button>
    </div>
</section>

<div class="border m-60"></div>

<section class="form-edit_group">
    <form class="form_edit" [formGroup]="editGroupForm">
        <div class="form-group w-80">
            <input type="text" formControlName="nameGroup" placeholder="Name">
        </div>
        <div class="field-row">
            <label>Please choose Mode of Group</label>
            <mat-radio-group
                aria-label="Select an option"
                formControlName="privacy">

                <mat-radio-button [value]="0"
                                  name="privacy"
                >Public
                </mat-radio-button>
                <mat-radio-button [value]="1"
                                  name="privacy"
                >Private
                </mat-radio-button>
            </mat-radio-group>

        </div>

        <div class="border"></div>
        <div class="add-description-action" (click)="addDescriptionHideShow()">
            <mat-icon [ngClass]="{'grey': addDescriptionSectionShow}">
                {{!addDescriptionSectionShow ? 'add' : 'close'}}
            </mat-icon>
            <span [ngClass]="{'grey': addDescriptionSectionShow}">
                    ADD DESCRIPTION
                </span>
        </div>
        <div class="field-row w-80" *ngIf="addDescriptionSectionShow">
            <textarea
                formControlName="description"
                placeholder="Type Text here..."
                class="form-group-textarea "></textarea>
        </div>
        <div class="form-submit_btn">
            <button (click)="updateGGroupInfo()">Save Changes</button>
        </div>

    </form>
</section>
